import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import type {
  JetAssignmentDateField,
  JetAssignmentSortBy,
  JetAssignmentSortDir,
  JetAssignmentStatus,
} from 'pages/Jet/shared/constants/assignmentStatus'

export type JetAssignmentItem = {
  id: number
  jetInstanceId: number
  jetInstanceName: string
  assignmentId: string
  jobId: string
  status: JetAssignmentStatus
  callReportStatus: JetAssignmentStatus | null
  shiftId: number | null
  associationId: number | null
  workerId: number | null
  workerName: string | null
  wsaStatus: string | null
  shiftCancelled: boolean
  returnRequested: boolean
  targetStartsAt: string
  targetEndsAt: string
  createdAt: string
  updatedAt: string
}

export type JetAssignmentItems = JetAssignmentItem[]

export type ListJetAssignmentsRequest = {
  limit?: number
  cursor?: string
  statuses?: JetAssignmentStatus[] | null
  assignmentId?: string | null
  shiftId?: number | null
  dateField?: JetAssignmentDateField
  daysAgo?: number | null
  sortBy?: JetAssignmentSortBy
  sortDir?: JetAssignmentSortDir
}

export type ListJetAssignmentsResponse = {
  items: JetAssignmentItems
  nextCursor?: string | null
  totalCount: number
}

// Lists `jet_assignment` rows (JET assignments + their WorkWhile mapping),
// filtered by status and a days-ago window, ordered server-side and paginated by
// opaque keyset cursor.
export const listJetAssignments = async (
  request: ListJetAssignmentsRequest
): Promise<ListJetAssignmentsResponse> => {
  const params = {
    limit: request.limit,
    cursor: request.cursor,
    statuses: request.statuses,
    assignment_id: request.assignmentId,
    shift_id: request.shiftId,
    date_field: request.dateField,
    days_ago: request.daysAgo,
    sort_by: request.sortBy,
    sort_dir: request.sortDir,
  }

  const response = await api.get<ListJetAssignmentsResponse>(
    '/admin/jet/assignments',
    {
      params,
      paramsSerializer: queryParamSerializer,
    }
  )
  return response.data
}
